import ShippingMedia from './components/ShippingMedia';
import React, { useMemo, useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom'; 
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3' 
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { ENDPOINT,CLIENT_CANVAS_WIDTH,CLIENT_CANVAS_DOUBLE_HEIGHT} from "constants/variables";
import { es } from 'date-fns/locale';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import Card from '@mui/material/Card';  
import CardContent from '@mui/material/CardContent'; 
import CircularProgress from '@mui/material/CircularProgress';  
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';  
import SearchIcon from '@mui/icons-material/Search';
import SignatureCanvas from 'react-signature-canvas';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import "css/empButtons.css"; 
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/shippingResponsive.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions"; 
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { NumericFormat } from 'components/utils/NumericFormat'; 
import TableSortingShippingArticleList from "pages/shipping/editOrNewShipping/SortingTablesShippingArticlesList";
import PropTypes from 'prop-types';  
import {
  INITIAL_ARTICLES,
  INITIAL_BUTTONS_ARTICLES,
  INITIAL_DATA_SHIPPING,
  INITIAL_TYPES,
  INITIAL_TYPES_DOCUMENTID,
  INITIAL_TYPES_PAYMENT,
  INITIAL_TYPES_VEHICLES,
  INITIAL_WORKPLACE,
  buildMenuPermissions,
} from "pages/shipping/editOrNewShipping/constants/shippingEditConstants";
import { useAutocompleteField } from "pages/shipping/editOrNewShipping/hooks/useAutocompleteField";
import ShippingDialogs from "pages/shipping/editOrNewShipping/components/ShippingDialogs";
import ShippingSearchOverlays from "pages/shipping/editOrNewShipping/components/ShippingSearchOverlays";
import ShippingWorkOptions from "pages/shipping/editOrNewShipping/components/ShippingWorkOptions";
import ShippingAutocompleteField from "pages/shipping/editOrNewShipping/components/ShippingAutocompleteField";
import { validateShipping, validateShippingRequired } from "pages/shipping/editOrNewShipping/utils/shippingValidation";
import { createShippingInitialState } from "pages/shipping/editOrNewShipping/utils/shippingInitialState";
import { persistShipping } from "pages/shipping/editOrNewShipping/utils/persistShipping";

const iNITIAL_DATA_SHIPPING = INITIAL_DATA_SHIPPING;

const ShippingEditOrCreate = ({id, showModalShippingsSettings,typeOfList}) => {
  const {t,i18n} = useTranslation(['listDataShipping']);
  const token = useSelector((state) => state.loginUser.token);  
  const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const defaultStore = useSelector((state) => state.loginUser.defaultStore)
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const defaulttypesdi = useSelector((state) => state.loginUser.defaulttypesdi);  
  const defaultsignature= useSelector((state) => state.loginUser.signature_default);
  const defaultEmployee = useSelector((state) => state.loginUser.defaultEmployee);
  const [formShipping, setFormShipping] = useState(() => createShippingInitialState(id, defaultEmployee));
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsForm, setErrorsForm] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [saveError, setSaveError] = useState('');
  const savingRef = useRef(false);
  const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
  const [showModalSearchTrailers, setShowModalSearchTrailers] = useState(false);
  const [showModalSearchDI, setShowModalSearchDI] = useState(false); 
  const [showModalSearchDrivers, setShowModalSearchDrivers] = useState(false); 
  const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
  const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false);  
  const [openDeleteRowArticles,setOpenDeleteRowArticles]= useState(false);
  const [idCodeDeleteArticle, setIdCodeDeleteArticle] = useState(DELETE_CODE);
  const [editRowArticles, setEditRowArticles] = useState(INITIAL_ARTICLES); 
  const [paymentTypeSelect,setPaymentTypeSelect]= useState(INITIAL_TYPES_PAYMENT); 
  const [typeOfPriceSelect,setTypeOfPriceSelect]= useState(INITIAL_TYPES); 
  const [semiTrailerTypeSelect,setSemiTrailerTypeSelect]= useState(INITIAL_TYPES); 
  const [craneModelTypeSelect,setCraneModelTypeSelect]= useState(INITIAL_TYPES); 
  const [articlesButtonsList,setArticlesButtonsList]= useState(INITIAL_BUTTONS_ARTICLES); 
  const [showModalSearchArticles, setShowModalSearchArticles] = useState(false);   
  const [tetxtSearch, setTetxtSearch] = useState("Rel_Trans");   
  const [expanded, setExpanded] =  useState(true);
  const [expandedOpt, setExpandedOpt] =  useState(true);
  const [expandedDest, setExpandedDest] =  useState(true);
  const [openChangeTypeOfPrice, setOpenChangeTypeOfPrice] = useState(false);
  const [workPlaceToSelect,setWorkPlaceToSelect]= useState(INITIAL_WORKPLACE);  
  const [workPlaceOriginToSelect,setWorkPlaceOriginToSelect]= useState(INITIAL_WORKPLACE);  
  const [workPlaceDestineToSelect,setWorkPlaceDestineToSelect]= useState(INITIAL_WORKPLACE);  
  
  const [trailersToSelect, setTrailersToSelect] = useState(INITIAL_TYPES_VEHICLES); 
  const trailerAutocomplete = useAutocompleteField({
    items: trailersToSelect,
    searchBy: (trailer) => trailer?.vehiclestore_licenseplate || "",
    inputValue: formShipping.vehiclestore_trailer,
     onSelect: (trailer) => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_trailer: trailer?.vehiclestore_licenseplate || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_trailer: "",
      }));
    },
  });

  const workkPlaceAutocomplete = useAutocompleteField({
    items: workPlaceToSelect,
    searchBy: (store) => store?.workplace || "",
    inputValue: formShipping.workplace,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        workplace: store?.workplace || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        workplace: "",
      }));
    },
  });

  const workkPlaceOriginAutocomplete = useAutocompleteField({
    items: workPlaceOriginToSelect,
    searchBy: (store) => store?.workplace || "",
    inputValue: formShipping.origin_street,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        origin_street: store?.workplace || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        origin_street: "",
      }));
    },
  });

  const workkPlaceDestineAutocomplete = useAutocompleteField({
    items: workPlaceDestineToSelect,
    searchBy: (store) => store?.workplace || "",
    inputValue: formShipping.destine_street,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        destine_street: store?.workplace || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        destine_street: "",
      }));
    },
  });

  const [vehiclesToSelect, setVehiclesToSelect] = useState(INITIAL_TYPES_VEHICLES); 
  const vehicleAutocomplete = useAutocompleteField({
    items: vehiclesToSelect,
    searchBy: (vehicle) => vehicle?.vehiclestore_licenseplate || "",
    inputValue: formShipping.vehiclestore_licenseplate,
    onSelect: (vehicle) => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_licenseplate: vehicle?.vehiclestore_licenseplate || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_licenseplate: "",
      }));
    },
  });
  const [documentIdRelTransToSelect, setDocumentIdRelTransToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const relTransDocumentIdAutocomplete = useAutocompleteField({
    items: documentIdRelTransToSelect,
    searchBy: (store) => store?.documentid || "",
    inputValue: formShipping.rel_trans_documentid,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        rel_trans_documentid: store?.documentid || "",
        rel_trans_tradename: store?.tradename || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        rel_trans_documentid: "",
        rel_trans_tradename: "",
      }));
    },
  });
  const [tradenameRelTransToSelect, setTradenameRelTransToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const relTransTradenameAutocomplete = useAutocompleteField({
    items: tradenameRelTransToSelect,
    searchBy: (store) => store?.tradename || "",
    inputValue: formShipping.rel_trans_tradename,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        rel_trans_tradename: store?.tradename || "",
        rel_trans_documentid: store?.documentid || prev.rel_trans_documentid,
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        rel_trans_tradename: "",
      }));
    },
  });
  const [documentIdOptToSelect, setDocumentIdOptToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const optTrasDocumentIdAutocomplete = useAutocompleteField({
    items: documentIdOptToSelect,
    searchBy: (store) => store?.documentid || "",
    inputValue: formShipping.opt_tras_documentid,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        opt_tras_documentid: store?.documentid || "",
        opt_tras_tradename: store?.tradename || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        opt_tras_documentid: "",
        opt_tras_tradename: "",
      }));
    },
  });
  
  const [tradenameOptToSelect, setTradenameOptToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const optTrasTradenameAutocomplete = useAutocompleteField({
    items: tradenameOptToSelect,
    searchBy: (store) => store?.tradename || "",
    inputValue: formShipping.opt_tras_tradename,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        opt_tras_tradename: store?.tradename || "",
        opt_tras_documentid: store?.documentid || prev.opt_tras_documentid,
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        opt_tras_tradename: "",
      }));
    },
  });
  const [documentIdDestToSelect, setDocumentIdDestToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const destTrasDocumentIdAutocomplete = useAutocompleteField({
    items: documentIdDestToSelect,
    searchBy: (store) => store?.documentid || "",
    inputValue: formShipping.dest_tras_documentid,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        dest_tras_documentid: store?.documentid || "",
        dest_tras_tradename: store?.tradename || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        dest_tras_documentid: "",
        dest_tras_tradename: "",
      }));
    },
  });
  const [tradenameDestToSelect, setTradenameDestToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const destTrasTradenameAutocomplete = useAutocompleteField({
    items: tradenameDestToSelect,
    searchBy: (store) => store?.tradename || "",
    inputValue: formShipping.dest_tras_tradename,
    onSelect: (store) => {
      setFormShipping((prev) => ({
        ...prev,
        dest_tras_tradename: store?.tradename || "",
        dest_tras_documentid: store?.documentid || prev.dest_tras_documentid,
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        dest_tras_tradename: "",
      }));
    },
  }); 
  const [documentIdDriverToSelect, setDocumentIdDriverToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const driverDocumentIdAutocomplete = useAutocompleteField({
    items: documentIdDriverToSelect,
    searchBy: (driver) => driver?.documentid || "",
    inputValue: formShipping.vehiclestore_documentid,
    onSelect: (driver) => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_documentid: driver?.documentid || "",
        vehiclestore_defaultdriver: driver?.tradename || "",
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_documentid: "",
        vehiclestore_defaultdriver: "",
      }));
    },
  });
   
  const [tradenameDriverToSelect, setTradenameDriverToSelect] = useState(INITIAL_TYPES_DOCUMENTID);
  const driverTradenameAutocomplete = useAutocompleteField({
    items: tradenameDriverToSelect,
    searchBy: (driver) => driver?.tradename || "",
    inputValue: formShipping.vehiclestore_defaultdriver,
    onSelect: (driver) => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_defaultdriver: driver?.tradename || "",
        vehiclestore_documentid: driver?.documentid || prev.vehiclestore_documentid,
      }));
    },
    onClear: () => {
      setFormShipping((prev) => ({
        ...prev,
        vehiclestore_defaultdriver: "",
      }));
    },
  });
  const menuPermissions = useMemo(
    () => buildMenuPermissions(roles),
    [roles]
  );
  const signDispatchedDriverCanvas = useRef(null);
  const signDispatchedChargerCanvas = useRef(null);
  const signDispatchedInspectorCanvas = useRef(null);
  const canViewExpandedDestination = roles?.some(role => role.listmenus?.some(menu => menu.name === "SubMenu_Shipping_EXPANDED_DESTINATION"));
  const canViewInspectorSignature = roles?.some(role => role.listmenus?.some(menu => menu.name === "SubMenu_Shipping_VIEW_INSPECTOR_SIGNATURE"));

  useEffect(() => {
    if (isLoadingData || !showModalShippingsSettings) return;
    const resizeCanvas = (ref) => {
      const canvas = ref.current?.getCanvas();
      if (!canvas) return;
      const width = Math.round(canvas.getBoundingClientRect().width);
      if (width <= 0 || width === canvas.width) return;
      const copy = document.createElement('canvas');
      copy.width = canvas.width;
      copy.height = canvas.height;
      copy.getContext('2d').drawImage(canvas, 0, 0);
      canvas.width = width;
      const scale = Math.min(width / copy.width, canvas.height / copy.height);
      canvas.getContext('2d').drawImage(copy,
        (width - copy.width * scale) / 2,
        (canvas.height - copy.height * scale) / 2,
        copy.width * scale, copy.height * scale);
    };
    const refs = [signDispatchedDriverCanvas, signDispatchedChargerCanvas];
    const observer = new ResizeObserver(() => refs.forEach(resizeCanvas));
    refs.forEach((ref) => {
      const canvas = ref.current?.getCanvas();
      if (canvas) observer.observe(canvas);
      resizeCanvas(ref);
    });
    return () => observer.disconnect();
  }, [isLoadingData, showModalShippingsSettings]);

  const dispatch = useDispatch();
  const navigate = useNavigate(); 

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const handleAccordionToggle = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  const handleAccordionOptToggle = (e) => {
    e.stopPropagation();
    setExpandedOpt((prev) => !prev);
  };

  const handleAccordionDestToggle = (e) => {
    e.stopPropagation();
    setExpandedDest((prev) => !prev);
  };

  const handleCancelChangeTypeOfPrice = useCallback(() => {
    setOpenChangeTypeOfPrice(false);
  }, []);

  const handleConfirmChangeTypeOfPrice = useCallback(async (e) => {
    if (e?.key === "Escape") return;
    try {
      const prev = formShipping;
      const totalnetoservice =
        (Number(prev.weight || 0) * Number(prev.price_weight || 0)) *
        (prev.taxincluded ? 1 : (1 + Number(prev.tax || 0) / 100));
      let totalNeto = totalnetoservice;
      const updatedLines = await Promise.all(
        prev.linesshipping.map(async (line) => {
          let estimatedprice = Number(line.estimatedprice || 0);
          let hasLastPrice = false;
          if (
            prev?.dest_tras_store_id &&
            prev.dest_tras_store_id !== "" &&
            prev.dest_tras_store_id !== "0" &&
            prev.dest_tras_store_id !== 0 &&
            line?.article_id
          ) {
            const lastPrice = await helpHttp().get8(
              ENDPOINT,
              `shipping/getlastpricearticledesttrasstoreid`,
              token,
              line.article_id,
              prev.dest_tras_store_id
            );
            if (!lastPrice?.err && Number(lastPrice) > 0) {
              estimatedprice = Number(lastPrice);
              hasLastPrice = true;
            }
          }
          if (!hasLastPrice) {
            const priceMatch = line.articlestoretypesofprices?.find(
              p => Number(p.typesofprice_id) === Number(prev.typeofprice_id)
            );
            estimatedprice = priceMatch
              ? Number(priceMatch.saleprice || 0)
              : Number(line.estimatedprice || 0);
          }
          const totalLine =
            (estimatedprice * Number(line.amount || 0)) *
            (1 - Number(line.discount || 0) / 100) *
            (line.taxincluded ? 1 : (1 + Number(line.tax || 0) / 100));
          totalNeto += totalLine;
          return {
            ...line,
            estimatedprice,
            total: totalLine
          };
        })
      );
      setFormShipping(prev => ({
        ...prev,
        linesshipping: updatedLines,
        totalnetoservice,
        totalnetoshipping: totalNeto
      }));
      setOpenChangeTypeOfPrice(false);
    } catch (error) {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    }
  }, [formShipping, token, dispatch, t]);
   
  const resetAll = useCallback(() => {
    setFormShipping(iNITIAL_DATA_SHIPPING); 
    setFormShipping(formShipping => ({
        ...formShipping,
        linesshipping: [],
      }));
    dispatch(setLoading(false));
    setIsLoadingErrorData(false);
    setErrorsForm({});
    setShowModalSearchVehicles(false);
    setShowModalSearchTrailers(false);
    setShowModalSearchDI(false);
    setShowModalSearchDrivers(false);
    setShowModalSearchStores(false);
    setShowModalSearchStoresAddress(false);  
    setOpenDeleteRowArticles(false);
    setIdCodeDeleteArticle(DELETE_CODE);
    setEditRowArticles(INITIAL_ARTICLES); 
    setPaymentTypeSelect(INITIAL_TYPES_PAYMENT); 
    setTypeOfPriceSelect(INITIAL_TYPES);
    setSemiTrailerTypeSelect(INITIAL_TYPES);
    setCraneModelTypeSelect(INITIAL_TYPES);
    setArticlesButtonsList(INITIAL_BUTTONS_ARTICLES);
    setShowModalSearchArticles(false);
    setTetxtSearch("Rel_Trans"); 
    setExpanded(true); 
    setExpandedOpt(true); 
    setExpandedDest(true);  
    setOpenChangeTypeOfPrice(false);
    setWorkPlaceToSelect(INITIAL_WORKPLACE);
    setWorkPlaceOriginToSelect(INITIAL_WORKPLACE);
    setWorkPlaceDestineToSelect(INITIAL_WORKPLACE);
    setVehiclesToSelect(INITIAL_TYPES_VEHICLES);
    setDocumentIdRelTransToSelect(INITIAL_TYPES_DOCUMENTID);
    setTradenameRelTransToSelect(INITIAL_TYPES_DOCUMENTID);
    setDocumentIdOptToSelect(INITIAL_TYPES_DOCUMENTID);
    setTradenameOptToSelect(INITIAL_TYPES_DOCUMENTID);
    setDocumentIdDestToSelect(INITIAL_TYPES_DOCUMENTID);
    setTradenameDestToSelect(INITIAL_TYPES_DOCUMENTID); 
    setDocumentIdDriverToSelect(INITIAL_TYPES_DOCUMENTID);
    setTradenameDriverToSelect(INITIAL_TYPES_DOCUMENTID); 
    if (signDispatchedDriverCanvas.current) signDispatchedDriverCanvas.current.clear();
    if (signDispatchedChargerCanvas.current) signDispatchedChargerCanvas.current.clear();
    if (signDispatchedInspectorCanvas.current) signDispatchedInspectorCanvas.current.clear();
  }, [dispatch,DELETE_CODE]);
  
  const handleCloseDataEditShipping = useCallback(() => {
    if (savingRef.current) return;
    resetAll();
     navigate(typeOfList==="1"?"/shipping":typeOfList==="2"?"/shippingended":"/home"); 
  }, [navigate, resetAll,typeOfList]);
  
  const onGlobalKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape" && showModalShippingsSettings) {
        handleCloseDataEditShipping();
      }
    },
    [handleCloseDataEditShipping, showModalShippingsSettings]
  );

  useEffect(() => {
    document.addEventListener("keydown", onGlobalKeyDown);
    return () => document.removeEventListener("keydown", onGlobalKeyDown);
  }, [onGlobalKeyDown]);
   
  const deleteSignature = (id) => {
    switch (id) {
      case 1:   
        if (signDispatchedDriverCanvas.current) signDispatchedDriverCanvas.current.clear();
        setFormShipping(formShipping => ({
          ...formShipping,
          signature_driver: "",
        }));
        break;
      case 2:    
        if (signDispatchedChargerCanvas.current) signDispatchedChargerCanvas.current.clear();
        setFormShipping(formShipping => ({
          ...formShipping,
          signature_charger: "",
        }));
        break;
      case 3:
        if (signDispatchedInspectorCanvas.current) signDispatchedInspectorCanvas.current.clear();
        setFormShipping(previous => ({ ...previous, signature_inspector: "" }));
        break;
      default:
        break;
    } 
  };

  const drawSignatureCentered = (canvasRef, base64) => {
    if (!canvasRef?.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    const signatureWidth = canvas.width;
    const signatureHeight = canvas.height;
    ctx.clearRect(0, 0, signatureWidth, signatureHeight);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        signatureWidth / imgWidth,
        signatureHeight / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (signatureWidth - drawWidth) / 2;
      const y = (signatureHeight - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
    };
  };

  const handleSetSignatureDriver = () => {
    if (!signDispatchedDriverCanvas.current) return;
    const canvasRef = signDispatchedDriverCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    const signatureWidth = canvas.width;
    const signatureHeight = canvas.height;
    ctx.clearRect(0, 0, signatureWidth, signatureHeight);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        signatureWidth / imgWidth,
        signatureHeight / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (signatureWidth - drawWidth) / 2;
      const y = (signatureHeight - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormShipping(formShipping => ({
            ...formShipping,
            signature_driver: base64
        }));
    };
  };
   
  const handleSetSignatureCharger = () => {
    if (!signDispatchedChargerCanvas.current) return;
    const canvasRef = signDispatchedChargerCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    const signatureWidth = canvas.width;
    const signatureHeight = canvas.height;
    ctx.clearRect(0, 0, signatureWidth, signatureHeight);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        signatureWidth / imgWidth,
        signatureHeight / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (signatureWidth - drawWidth) / 2;
      const y = (signatureHeight - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormShipping(formShipping => ({
            ...formShipping,
            signature_charger: base64
        }));
    };
  };

  const handleSetSignatureInspector = () => {
    if (!signDispatchedInspectorCanvas.current) return;
    const canvasRef = signDispatchedInspectorCanvas.current;
    const canvas = canvasRef.getCanvas();
    const ctx = canvas.getContext("2d");
    const signatureWidth = canvas.width;
    const signatureHeight = canvas.height;
    ctx.clearRect(0, 0, signatureWidth, signatureHeight);
    const img = new Image();
    img.src = defaultsignature;
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      const scale = Math.min(
        signatureWidth / imgWidth,
        signatureHeight / imgHeight
      );
      const drawWidth = imgWidth * scale;
      const drawHeight = imgHeight * scale;
      const x = (signatureWidth - drawWidth) / 2;
      const y = (signatureHeight - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const base64 = canvasRef
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormShipping(formShipping => ({
            ...formShipping,
            signature_inspector: base64
        }));
    };
  };
  
  const withValueCap3 = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000000) return true;
    return false;
  };


  const handleChangeDataEditShipping = (e) => {
    const { name, value } = e.target;
    setFormShipping(formShipping => ({
      ...formShipping,
      [name]: value,
    }));
  };

  const handleBlurDataEditShipping = (e) => {
    handleChangeDataEditShipping(e);
    setErrorsForm(validateFormShipping());
  };

  const handleChangeDataTypeOfPrice = (e) => {
    const { value } = e.target;
    setFormShipping(formShipping => ({
      ...formShipping,
      typeofprice_id: value
    }));
    if (Number(formShipping.typeofprice_id)!==Number(value) && formShipping?.linesshipping && formShipping.linesshipping.length>0 ){
     setOpenChangeTypeOfPrice(true);
    }
  };

  const handleBlurDataEditTypeOfPrice = (e) => {
    handleChangeDataTypeOfPrice(e);
    setErrorsForm(validateFormShipping());
  };

  const handleBlurDataEditCraneModel = (e) => {
    handleChangeDataCraneModel(e);
    setErrorsForm(validateFormShipping());
  };

  const handleChangeDataCraneModel = (e) => {
    const { value } = e.target;
    setFormShipping(formShipping => ({
      ...formShipping,
      cranemodel_id: value
    })); 
  };

   const handleBlurDataEditTypeOfSemiTrailer = (e) => {
    handleChangeDataTypeOfSemiTrailer(e);
    setErrorsForm(validateFormShipping());
  };

  const handleChangeDataTypeOfSemiTrailer = (e) => {
    const { value } = e.target;
    setFormShipping(formShipping => ({
      ...formShipping,
      semitrailertype_id: value
    })); 
  };

  const handleChangeSelectDate = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      date_shipping: event!==null?new Date(event):null
    }));
  };

  const handleBlurSelectDate = () => {
    setErrorsForm(validateFormShipping());
  };
  
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 1000000) return true;
    return false;
  };

  const handleChangeDataEditShippingWeight = (e) => {
    const { value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","").replaceAll("kg","").replaceAll("€","").replaceAll("%","").replaceAll(" ","")):0;
    setFormShipping(formShipping => ({
      ...formShipping,
      weight: newValue,
    }));
    let totalnetoservice=(newValue*formShipping.price_weight)*(formShipping.taxincluded?1:(1+(formShipping.tax/100)));
    const updatedLines = [...formShipping.linesshipping];
    let totalNeto = updatedLines.reduce((acc, item) => acc + (item.total || 0), 0);
    setFormShipping(formShipping => ({
      ...formShipping,
      totalnetoservice: totalnetoservice,
      totalnetoshipping: totalNeto+totalnetoservice
    })); 
  };

  const handleBlurDataEditShippingWeight = (e) => {
    handleChangeDataEditShippingWeight(e);
    setErrorsForm(validateFormShipping());
  };
 
  const handleBlurSelectHours = (e) => {
    handleChangeSelectHours(e);
     setErrorsForm(validateFormShipping());
  };

  const handleChangeSelectHours = (newValue) => { 
    setFormShipping(formShipping => ({
      ...formShipping,
      hours: newValue!==null?new Date(newValue):null
    }));
    
  }; 
  
  const deleteLicensePlate = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      vehiclestore_id:0,
      vehiclestore_licenseplate: "",
      vehiclestore_documentid:"",
      vehiclestore_defaultdriver: "",
      vehiclestore_trailer:""
    }));
    setErrorsForm(validateFormShipping());
  };

  const searchVehicles = (event) => {
    setShowModalSearchVehicles(true);
  };

  const deleteTrailer = () => {
    
    if (formShipping.vehiclestore_licenseplate===""){
      setFormShipping(formShipping => ({
        ...formShipping,
        vehiclestore_id:0,
        vehiclestore_documentid:"",
        vehiclestore_defaultdriver: "",
        vehiclestore_trailer:""
      }))
    }else{
      setFormShipping(formShipping => ({
        ...formShipping,
        vehiclestore_trailer:""
      }))
    } 
    setErrorsForm(validateFormShipping());
  };

  const deleteStoreOptTras = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      opt_tras_store_id:0,
      opt_tras_documentid: "",
      opt_tras_tradename:"",
      opt_tras_street: ""
       
    }));
    setErrorsForm(validateFormShipping());
  };

  const searchStoreOptTras = (event) => {
    setTetxtSearch("Opt_Tras")
    setShowModalSearchStores(true);
  };

  const deleteAddresStoreOptTras = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      opt_tras_street: ""
       
    }));
    setErrorsForm(validateFormShipping());
  };

  const searchAddresStoreOptTras = (event) => {
    setTetxtSearch("Opt_Tras")
    setShowModalSearchStoresAddress(true);
  };

  const deleteStoreDestTras = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      dest_tras_store_id:0,
      dest_tras_documentid: "",
      dest_tras_tradename:"",
      dest_tras_street: "",
      typeofprice_id:1, 
      paymenttype_id:1
       
    }));
    setErrorsForm(validateFormShipping()); 
    if (menuPermissions.canViewPrice && Number(formShipping.typeofprice_id)!==Number(1) && formShipping?.linesshipping && formShipping.linesshipping.length>0 ){
      setOpenChangeTypeOfPrice(true);
    }   
  };

  const searchStoreDestTras = (event) => {
    setTetxtSearch("Dest_Tras")
    setShowModalSearchStores(true);
  };

  const deleteAddresStoreDestTras = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      dest_tras_street: ""
       
    }));
    setErrorsForm(validateFormShipping());
  };

  const deleteFORMDI = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      formdi_id:0,
      ownformdi_id: "" 
       
    }));
    setErrorsForm(validateFormShipping());
  };
  
  const searchFORMDI= (event) => { 
    setShowModalSearchDI(true);
  };

  const searchDRIVER= (event) => { 
    setShowModalSearchDrivers(true);
  };
   
  const searchAddresStoreDestTras = (event) => {
    setTetxtSearch("Dest_Tras")
    setShowModalSearchStoresAddress(true);
  };

  const deleteStoreRelTrans = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      rel_trans_store_id:0,
      rel_trans_documentid: "",
      rel_trans_tradename:""
      
    }));
    setErrorsForm(validateFormShipping());
  };

  const searchStoreRelTrans = (event) => {
    setTetxtSearch("Rel_Trans")
    setShowModalSearchStores(true);
  };

  const deleteAddresStoreRelTrans = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      rel_trans_street: ""
       
    }));
    setErrorsForm(validateFormShipping());
  };

  const searchAddresStoreRelTrans = (event) => {
    setTetxtSearch("Rel_Trans")
    setShowModalSearchStoresAddress(true);
  };

  const deleteADriverStoreRelTrans = (event) => {
    setFormShipping(formShipping => ({
      ...formShipping,
      vehiclestore_defaultdriver:"",
      vehiclestore_documentid: ""
    }));
    setErrorsForm(validateFormShipping());
  };

  const handleChangeWithCrane = (event) => { 
    let withcranes=!formShipping.withcrane;
    setFormShipping(formShipping => ({
      ...formShipping,
      withcrane: withcranes
    })); 
    if(withcranes){
      setFormShipping(formShipping => ({
        ...formShipping,
        withoutcrane: false,
        adr: false,
        others: false,
      })); 
    } 
  };

  const handleChangeWitOutCrane = (event) => { 
    let withoutcranes=!formShipping.withoutcrane;
    setFormShipping(formShipping => ({
      ...formShipping,
      withoutcrane: withoutcranes
    })); 
     if(withoutcranes){
      setFormShipping(formShipping => ({
        ...formShipping,
        withcrane: false,
        adr: false,
        others: false,
      })); 
    } 
  };

  const handleChangeWitOutADR = (event) => { 
    let adrs=!formShipping.adr;
    setFormShipping(formShipping => ({
      ...formShipping,
      adr: adrs
    })); 
    if(adrs){
      setFormShipping(formShipping => ({
        ...formShipping,
        withcrane: false,
        withoutcrane: false,
        others: false,
      })); 
    }

  };

  const handleChangeWitOutOTHERS = (event) => { 
    let other=!formShipping.others;
    setFormShipping(formShipping => ({
      ...formShipping,
      others: other
    })); 
    if(other){
      setFormShipping(formShipping => ({
        ...formShipping,
        withcrane: false,
        withoutcrane: false,
        adr: false,
      })); 
    }
  };

  const handleCancelDeleteRow = () => { 
    setEditRowArticles(INITIAL_ARTICLES); 
    dispatch(setLoading(false));  
    setIsLoadingErrorData(false);
    setIdCodeDeleteArticle(DELETE_CODE);
    setOpenDeleteRowArticles(false);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteArticle(value);
  };

  const handleCloseDeleteRow = (e) => {
    e.preventDefault();
    if (idCodeDeleteArticle!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formShipping.linesshipping.findIndex(((item) => item.indexrowarticle === editRowArticles.indexrowarticle));
      if ( indexDelete !== -1 ) {
        formShipping.linesshipping.splice( indexDelete, 1 );
      }
      setFormShipping(formShipping => ({
        ...formShipping,
      })) 
      const updatedLines = [...formShipping.linesshipping];
      let totalNeto = updatedLines.reduce((acc, item) => acc + (item.total || 0), 0);
      setFormShipping((prev) => ({
        ...prev,
        totalnetoshipping: totalNeto+formShipping.totalnetoservice,
      })); 
      setIdCodeDeleteArticle(DELETE_CODE);
      setOpenDeleteRowArticles(false);
    }
  };

  const selectArticle = async (post) => {
    try {
      const selectedTypeOfPrice = post.articlestoretypesofprices?.find(
        (item) => Number(item.typesofprice_id) === Number(formShipping.typeofprice_id)
      );
      let estimatedPrice = Number(selectedTypeOfPrice?.saleprice ?? 0);
      if (
        formShipping?.dest_tras_store_id &&
        formShipping.dest_tras_store_id !== "" &&
        formShipping.dest_tras_store_id !== "0" &&
        formShipping.dest_tras_store_id !== 0 &&
        post?.article_id
      ) {
        const lastPrice = await helpHttp().get8(  ENDPOINT,  `shipping/getlastpricearticledesttrasstoreid`, token, post.article_id, formShipping.dest_tras_store_id );
        if (!lastPrice?.err && Number(lastPrice) > 0) {
          estimatedPrice = Number(lastPrice);
        }
      }
      const articleToAdd = {
        id: "",
        indexrowarticle:  formShipping.linesshipping.length > 0 ? formShipping.linesshipping[formShipping.linesshipping.length - 1].indexrowarticle + 1 : 1,
        shipping_id: formShipping.id,
        substore_id: formShipping.substore_id,
        substore_name: formShipping.substore_name,
        article_id: post.article_id,
        article_owncode: post.article_owncode,
        article_codean: post.article_codean,
        article_barcode: post.article_barcode,
        article_codeler: post.article_codeler,
        article_namees: post.article_namees,
        article_nameen: post.article_nameen,
        datepurchase: formShipping.datepurchase,
        amount: 1,
        estimatedprice: estimatedPrice,
        discount: 0,
        tax: post.article_tax,
        taxincluded: post.article_taxincluded,
        total:
          estimatedPrice *
          (post.article_taxincluded
            ? 1
            : 1 + Number(post.article_tax || 0) / 100),
        articlestoretypesofprices: post.articlestoretypesofprices
      };
      const updatedLines = [...formShipping.linesshipping, articleToAdd];
      const totalNeto = updatedLines.reduce(
        (acc, item) => acc + Number(item.total || 0),
        0
      );
      setFormShipping((prev) => ({
        ...prev,
        linesshipping: updatedLines,
        totalnetoshipping: totalNeto + Number(prev.totalnetoservice || 0)
      }));
    } catch (error) {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    }
  };
  
  const validateFormShipping = () => validateShipping(formShipping);
       
  const [mediaBusy, setMediaBusy] = useState(false);
  const handleConfirmFetchDataEditShipping = (dataToSend, hasWarnings) => {
    if (mediaBusy) { setSaveError('Termina la captura de foto o audio antes de guardar.'); return; }
    dataToSend = { ...dataToSend, updatedFiles: formShipping.updatedFiles || [] };
    if (savingRef.current) return;
    savingRef.current = true;
    setIsSaving(true);
    setSaveError('');
    const fetchData = async () => {
      try {
        const getData = await persistShipping(() => id !== "0"
          ? helpHttp().put(
              ENDPOINT,
              `shipping/updateshipping`,
              token,
              dataToSend,
              120000
            )
          : helpHttp().post(
              ENDPOINT,
              `shipping/saveshipping`,
              token,
              dataToSend,
              120000
            ), (failure) => {
              const message = t('Text_Shipping_SaveFailedRetained');
              setSaveError(message);
              dispatch(warningErrorAction(
                failure?.cause ? `${t(failure.cause)}. ${message}` : message
              ));
            });
        if (!getData) return;
        if (getData.status === "OK") {
          savingRef.current = false;
          setIsSaving(false);
          dispatch(successErrorAction(t('Text_SaveData')));
          if (hasWarnings) {
            dispatch(warningErrorAction(t('Text_Shipping_SavedWithWarnings')));
          }
          handleCloseDataEditShipping();
          if (!menuPermissions.canAutoDeca) return;
          const shippingId = getData.response?.id || dataToSend?.id;
          if (!shippingId) {
            dispatch(warningErrorAction(t('Text_DeCA_AutomaticError')));
            return;
          }
          try {
            const decaStart = await helpHttp().post(
              ENDPOINT,
              `shipping/generatedeca/${shippingId}`,
              token,
              {}
            );
            let decaData = decaStart;
            for (let attempt = 0;
              decaData.status === "ACCEPTED" && attempt < 120;
              attempt += 1) {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              decaData = await helpHttp().get(
                ENDPOINT,
                `shipping/generatedeca/status/${shippingId}`,
                token
              );
            }
            if (decaData.status === "OK") {
              window.dispatchEvent(new CustomEvent('shipping-deca-generated', {
                detail: { shippingId }
              }));
            } else if (decaData.cause === "Text_DeCA_MissingFields") {
              dispatch(warningErrorAction(t('Text_DeCA_Incomplete')));
            } else {
              dispatch(warningErrorAction(t('Text_DeCA_AutomaticError')));
            }
          } catch (decaError) {
            dispatch(warningErrorAction(t('Text_DeCA_AutomaticError')));
          }
        } else {
          dispatch(warningErrorAction(t(getData.cause)));
        }
      } catch (error) {
        const message = t('Text_Shipping_SaveFailedRetained');
        setSaveError(message);
        dispatch(warningErrorAction(message));
      } finally {
        if (savingRef.current) {
          savingRef.current = false;
          setIsSaving(false);
        }
      }
    };
    return fetchData();
  };
  
  const handleSubmitDataEditShipping = () => {
    if (savingRef.current) return;
    const errors = validateFormShipping();
    const requiredErrors = validateShippingRequired(formShipping);
    setErrorsForm(errors);
  
    if (
      Object.keys(requiredErrors).length === 0
    ) {
      let signatureDriver = formShipping.signature_driver;
      let signatureCharger = formShipping.signature_charger;
      let signatureInspector = formShipping.signature_inspector;
  
      if (signDispatchedDriverCanvas.current && !signDispatchedDriverCanvas.current.isEmpty()) {
        signatureDriver = signDispatchedDriverCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
  
      if (signDispatchedChargerCanvas.current && !signDispatchedChargerCanvas.current.isEmpty()) {
        signatureCharger = signDispatchedChargerCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }
  
      if (canViewInspectorSignature && signDispatchedInspectorCanvas.current && !signDispatchedInspectorCanvas.current.isEmpty()) {
        signatureInspector = signDispatchedInspectorCanvas.current.getTrimmedCanvas().toDataURL("image/png");
      }

      const formToSend = {
        ...formShipping,
        signature_driver: signatureDriver,
        signature_charger: signatureCharger,
        signature_inspector: signatureInspector
      };
      handleConfirmFetchDataEditShipping(formToSend, Object.keys(errors).length > 0);
    
    } else {
      dispatch(warningErrorAction(t(Object.values(requiredErrors)[0])));
    }
  }; 

   const isValidPngDataURL = (value) => {
    if (typeof value !== "string") return false;
    const trimmed = value.trim();
    if (trimmed==="") return false;
    if (trimmed.includes("static/media")) return true; 
    if (!trimmed.startsWith("data:image/png;base64,")) return false;
    // longitud mínima razonable para un PNG (ajusta si quieres)
    return trimmed.length > 200; 
  };

  useEffect(() => {
      let isMounted = true; 
      const fetchDataPayment = async () => {
        try {
          const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `shipping/paymenttypesorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `shipping/paymenttypesorderbynameen`, token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setPaymentTypeSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 
      const fetchDataButtons = async () => {
        try {
          const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `shipping/getbuttonsorderbybamees`, token)
          : await helpHttp().get(ENDPOINT, `shipping/getbuttonsorderbybameen`, token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setArticlesButtonsList(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 

       const fetchDataSemiTrailer = async () => {
        try {
          const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `shipping/typesofsemitrailerorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `shipping/typesofsemitrailerorderbynameen`, token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setSemiTrailerTypeSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 

       const fetchDataCraneModel = async () => {
        try {
          const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `shipping/cranemodelorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `shipping/cranemodelorderbynameen`, token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setCraneModelTypeSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 

      const fetchDataTypesOfPrices = async () => {
        try {
          const getData = i18n.language === "es"
          ? await helpHttp().get(ENDPOINT, `shipping/typesofpriceorderbynamees`, token)
          : await helpHttp().get(ENDPOINT, `shipping/typesofpriceorderbynameen`, token);
          if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            setTypeOfPriceSelect(getData);
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }; 
      if (showModalShippingsSettings ) {  
        fetchDataPayment();  
        fetchDataSemiTrailer();
        fetchDataCraneModel();
        fetchDataTypesOfPrices();
        fetchDataButtons();
      }
      return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,showModalShippingsSettings]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataShipping = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await  helpHttp().get2(ENDPOINT,`shipping/getshippingbyid/`,token,id);
        if (getData.err) {
          setFormShipping(iNITIAL_DATA_SHIPPING);
          setIsLoadingErrorData(true);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (isMounted) { 
          let totalnetoservice=(getData.weight*getData.price_weight)*(getData.taxincluded?1:(1+(getData.tax/100)));
          const updatedLines = [...getData.linesshipping];
          let totalNeto = updatedLines.reduce((acc, item) => acc + (item.total || 0), 0);
          setFormShipping(getData); 
          setFormShipping((prev) => ({
            ...prev,
            typeofprice_id: getData?.typeofprice_id &&  Number(getData.typeofprice_id>0)?Number(getData.typeofprice_id):1,
            paymenttype_id: getData?.paymenttype_id &&  Number(getData.paymenttype_id>0)?Number(getData.paymenttype_id):1,
            totalnetoservice: totalnetoservice,
            totalnetoshipping: totalNeto+totalnetoservice
          }));
           if (getData.signature_charger && isValidPngDataURL(getData.signature_charger)) {
            setTimeout(() => {
              if (signDispatchedChargerCanvas.current) {
                drawSignatureCentered(signDispatchedChargerCanvas, getData.signature_charger);
              }
            }, 200);
          }   
if (getData.signature_inspector && isValidPngDataURL(getData.signature_inspector)) {
            setTimeout(() => {
              if (signDispatchedInspectorCanvas.current) {
                drawSignatureCentered(signDispatchedInspectorCanvas, getData.signature_inspector);
              }
            }, 200);
          }   
          if (getData.signature_driver && isValidPngDataURL(getData.signature_driver)) {
            setTimeout(() => {
              if (signDispatchedDriverCanvas.current) {
                drawSignatureCentered(signDispatchedDriverCanvas, getData.signature_driver);
              }
            }, 200);
          } 
          dispatch(setLoading(false));
        }  
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };

    if (id!=="0"){
      if (formShipping.id===""){
        fetchDataShipping();  
      }
    }else{
      //setFormShipping(iNITIAL_DATA_SHIPPING);
      setFormShipping(formShipping => ({
        ...formShipping,
        defaultStore_id:defaultStore.id,
        useraccount_id:useraccount_id,
        defaultformatnumber:defaulttypesdi.id
      })); 
      dispatch(setLoading(false));
    }
    return () => { isMounted = false };
  }, [dispatch,id,t,token,formShipping.id,defaulttypesdi,defaultStore.id,useraccount_id,isLoadingData]);  

 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdRelTrans = async () => {
        try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistdocumentidsh/`,token,
            (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setDocumentIdRelTransToSelect(getData); 
        }
        } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };   
    if (showModalShippingsSettings){
        if (formShipping.rel_trans_documentid && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
            fetchDataDocumentIdRelTrans();
        }
    } else{
        setDocumentIdRelTransToSelect(INITIAL_TYPES_DOCUMENTID);
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.rel_trans_documentid,showModalShippingsSettings]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehicles = async () => {
      try {
        const getData = await helpHttp().get8(ENDPOINT,`shipping/getlistvehiclesshipping`,token,
          (formShipping.vehiclestore_licenseplate!==undefined && formShipping.vehiclestore_licenseplate!==null && formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim():"-1",
          (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setVehiclesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalShippingsSettings && ((formShipping.vehiclestore_licenseplate && formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!=="") || (formShipping.rel_trans_documentid && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""))) { 
      fetchDataVehicles();
    }else{
      setVehiclesToSelect(INITIAL_TYPES_VEHICLES);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.vehiclestore_licenseplate,showModalShippingsSettings,formShipping.rel_trans_documentid]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataTrailers = async () => {
      try {
        const getData = await helpHttp().get8(ENDPOINT,`shipping/getlisttrailersshipping`,token,
          (formShipping.vehiclestore_trailer!==undefined && formShipping.vehiclestore_trailer!==null && formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim():"-1",
          (formShipping.rel_trans_documentid!==undefined && formShipping.rel_trans_documentid!==null && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTrailersToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    
    if (showModalShippingsSettings && ((formShipping.vehiclestore_trailer && formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim()!=="") || (formShipping.rel_trans_documentid && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""))) { 
      fetchDataTrailers();
    }else{
      setTrailersToSelect(INITIAL_TYPES_VEHICLES);
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.vehiclestore_trailer,showModalShippingsSettings,formShipping.rel_trans_documentid]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdDriver = async () => {
        try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistdocumentiddriver/`,token,
            (formShipping.vehiclestore_documentid!==undefined && formShipping.vehiclestore_documentid!==null && formShipping.vehiclestore_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.vehiclestore_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setDocumentIdDriverToSelect(getData); 
        }
        } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };   
    if (showModalShippingsSettings){
      if (formShipping.vehiclestore_documentid && formShipping.vehiclestore_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentIdDriver();
      }
    } else{
      setDocumentIdDriverToSelect(INITIAL_TYPES_DOCUMENTID);
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.vehiclestore_documentid,showModalShippingsSettings]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataWorkPlace = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistworplace/`,token,
            (formShipping.dest_tras_documentid!==undefined && formShipping.dest_tras_documentid!==null && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setWorkPlaceToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalShippingsSettings){
      if (formShipping.dest_tras_documentid && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataWorkPlace();
      }
    } else{
      setWorkPlaceToSelect(INITIAL_WORKPLACE);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.dest_tras_documentid,showModalShippingsSettings]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataWorkPlace = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistworplace/`,token,
            (formShipping.dest_tras_documentid!==undefined && formShipping.dest_tras_documentid!==null && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setWorkPlaceOriginToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalShippingsSettings){
      if (formShipping.dest_tras_documentid && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataWorkPlace();
      }
    } else{
      setWorkPlaceOriginToSelect(INITIAL_WORKPLACE);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.dest_tras_documentid,showModalShippingsSettings]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataWorkPlace = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistworplace/`,token,
            (formShipping.dest_tras_documentid!==undefined && formShipping.dest_tras_documentid!==null && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setWorkPlaceDestineToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalShippingsSettings){
      if (formShipping.dest_tras_documentid && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataWorkPlace();
      }
    } else{
      setWorkPlaceDestineToSelect(INITIAL_WORKPLACE);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.dest_tras_documentid,showModalShippingsSettings]);
 

  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradenameDriver = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlisttradenamedriver/`,token,
            (formShipping.vehiclestore_defaultdriver!==undefined && formShipping.vehiclestore_defaultdriver!==null && formShipping.vehiclestore_defaultdriver.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.vehiclestore_defaultdriver.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setTradenameDriverToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalShippingsSettings){
      if (formShipping.vehiclestore_defaultdriver && formShipping.vehiclestore_defaultdriver.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataTradenameDriver();
      }
    } else{
      setTradenameDriverToSelect(INITIAL_TYPES_DOCUMENTID);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.vehiclestore_defaultdriver,showModalShippingsSettings]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdDest = async () => {
        try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistdocumentidsh/`,token,
            (formShipping.dest_tras_documentid!==undefined && formShipping.dest_tras_documentid!==null && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setDocumentIdDestToSelect(getData); 
        }
        } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };   
    if (showModalShippingsSettings){
      if (formShipping.dest_tras_documentid && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentIdDest();
      }
    } else{
      setDocumentIdDestToSelect(INITIAL_TYPES_DOCUMENTID);
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.dest_tras_documentid,showModalShippingsSettings]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradenameDest = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlisttradenamesh/`,token,
            (formShipping.dest_tras_tradename!==undefined && formShipping.dest_tras_tradename!==null && formShipping.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
            setTradenameDestToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalShippingsSettings){
      if (formShipping.dest_tras_tradename && formShipping.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataTradenameDest();
      }
    } else{
      setTradenameDestToSelect(INITIAL_TYPES_DOCUMENTID);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.dest_tras_tradename,showModalShippingsSettings]);
  
  useEffect(() => {
    let isMounted = true; 
    const fetchDataDocumentIdOpt = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getlistdocumentidsh/`,token,
          (formShipping.opt_tras_documentid!==undefined && formShipping.opt_tras_documentid!==null && formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
              setDocumentIdOptToSelect(getData); 
          }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   
    if (showModalShippingsSettings){
      if (formShipping.opt_tras_documentid && formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchDataDocumentIdOpt();
      }
    } else{
      setDocumentIdOptToSelect(INITIAL_TYPES_DOCUMENTID);
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.opt_tras_documentid,showModalShippingsSettings]);
  
  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradenameOpt = async () => {
        try {
            const getData = await helpHttp().get2(ENDPOINT,`shipping/getlisttradenamesh/`,token,
                (formShipping.opt_tras_tradename!==undefined && formShipping.opt_tras_tradename!==null && formShipping.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setTradenameOptToSelect(getData);
            }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };  
    if (showModalShippingsSettings){
      if (formShipping.opt_tras_tradename && formShipping.opt_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
            fetchDataTradenameOpt();
        }
    } else{
        setTradenameOptToSelect(INITIAL_TYPES_DOCUMENTID);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.opt_tras_tradename,showModalShippingsSettings]);
      
  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradenameRelTrans = async () => {
        try {
            const getData = await helpHttp().get2(ENDPOINT,`shipping/getlisttradenamesh/`,token,
                (formShipping.rel_trans_tradename!==undefined && formShipping.rel_trans_tradename!==null && formShipping.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formShipping.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setTradenameRelTransToSelect(getData);
            }
        } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
    };  
    if (showModalShippingsSettings){
        if (formShipping.rel_trans_tradename && formShipping.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
            fetchDataTradenameRelTrans();
        }
    } else{
        setTradenameRelTransToSelect(INITIAL_TYPES_DOCUMENTID);
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formShipping.rel_trans_tradename,showModalShippingsSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocumentRelTrans = async () => {
      try { 
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getexiststorebynumberdocument/`,token,formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formShipping.rel_trans_store_id){
            fetchStoreNumberDocumentRelTrans();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchStoreNumberDocumentRelTrans = async () => {
      try {
          const getData = await helpHttp().get5(ENDPOINT,`shipping/getstorebynumberdocumentpriority`,token,formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim(),6);
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            if (getData!==undefined && getData!==null && getData!==""){
              let street=(getData.street!==null && getData.street.street!==null)?getData.street.street+" ":"";
              let postalcode_postalcodename=(getData.street!==null && getData.street.postalcode_postalcodename!==null)?getData.street.postalcode_postalcodename:"";
              let adress=street+postalcode_postalcodename
              setFormShipping(formShipping => ({
                ...formShipping,
                rel_trans_store_id: getData.store_id, 
                rel_trans_tradename: getData.tradename,
                rel_trans_street:(adress!=="")?adress:formShipping.rel_trans_street
            }));
          }  
        }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formShipping.rel_trans_documentid && formShipping.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocumentRelTrans();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,formShipping.rel_trans_store_id,formShipping.rel_trans_documentid]);

  useEffect(() => { 
    const fetchExistLicensePlate = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getexistvehicleylicenseplate/`,token,formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
           if (getData>0 ){
            fetchLicensePlate(); 
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };

    const fetchLicensePlate = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getvehiclebylicenseplate/`,token,formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim());
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else {
              if (getData!==undefined && getData!==null && getData!==""){
                if (formShipping.vehiclestore_defaultdriver===undefined 
                  || formShipping.vehiclestore_defaultdriver===null
                  || formShipping.vehiclestore_defaultdriver===""
                ){
                  setFormShipping(formShipping => ({
                    ...formShipping,
                    vehiclestore_id: getData.id,
                    vehiclestore_documentid: getData.documentid,
                    vehiclestore_defaultdriver: getData.defaultdriver
                }));
              }  
              if (formShipping.rel_trans_documentid===undefined 
                || formShipping.rel_trans_documentid===null
                || formShipping.rel_trans_documentid===""
              ){
                setFormShipping(formShipping => ({
                  ...formShipping,
                  rel_trans_documentid:getData.store_documentid,
                  rel_trans_tradename: getData.store_tradename
                }))
              }
              if (formShipping.rel_trans_tradename===undefined 
                || formShipping.rel_trans_tradename===null
                || formShipping.rel_trans_tradename===""
              ){
                setFormShipping(formShipping => ({
                  ...formShipping,
                  rel_trans_tradename: getData.store_tradename
                }))
              }
              setFormShipping(formShipping => ({
                ...formShipping,
              }))
            }
          }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
      if (formShipping.vehiclestore_licenseplate && formShipping.vehiclestore_licenseplate.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistLicensePlate();  
    }  
    return () => {};
  }, [t,token,dispatch,formShipping.vehiclestore_licenseplate,formShipping.rel_trans_tradename,formShipping.rel_trans_documentid,formShipping.vehiclestore_defaultdriver]);
  
  useEffect(() => { 
    const fetchExistTrailer = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getexisttrailerbylicenseplate/`,token,formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else {
           if (getData>0 ){
            fetchTrailer(); 
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchTrailer = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`shipping/gettrailerbylicenseplate/`,token,formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim());
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else {
              if (getData!==undefined && getData!==null && getData!==""){
              if (formShipping.rel_trans_documentid===undefined 
                || formShipping.rel_trans_documentid===null
                || formShipping.rel_trans_documentid===""
              ){
                setFormShipping(formShipping => ({
                  ...formShipping,
                  rel_trans_documentid:getData.store_documentid,
                  rel_trans_tradename: getData.store_tradename
                }))
              }
              if (formShipping.rel_trans_tradename===undefined 
                || formShipping.rel_trans_tradename===null
                || formShipping.rel_trans_tradename===""
              ){
                setFormShipping(formShipping => ({
                  ...formShipping,
                  rel_trans_tradename: getData.store_tradename
                }))
              }
              setFormShipping(formShipping => ({
                ...formShipping,
              }))
            }
          }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (formShipping.vehiclestore_trailer && formShipping.vehiclestore_trailer.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistTrailer();  
    }  
    return () => {};
  }, [t,token,dispatch,formShipping.vehiclestore_trailer,formShipping.rel_trans_tradename,formShipping.rel_trans_documentid]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocumentOptTras = async () => {
      try { 
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getexiststorebynumberdocument/`,token,formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formShipping.opt_tras_store_id){
            fetchStoreNumberDocumentOptTras();
          }
        }
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchStoreNumberDocumentOptTras = async () => {
      try {
          const getData = await helpHttp().get5(ENDPOINT,`shipping/getstorebynumberdocumentpriority`,token,formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim(),1);
          if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
          } else if (isMounted) {
            if (getData!==undefined && getData!==null && getData!==""){
              let street=(getData.street!==null && getData.street.street!==null)?getData.street.street+" ":"";
              let postalcode_postalcodename=(getData.street!==null && getData.street.postalcode_postalcodename!==null)?getData.street.postalcode_postalcodename:"";
              let adress=street+postalcode_postalcodename
              setFormShipping(formShipping => ({
                ...formShipping,
                opt_tras_store_id: getData.store_id, 
                opt_tras_tradename: getData.tradename,
                opt_tras_street:(adress!=="")?adress:formShipping.opt_tras_street
              }));
          }  
        }         
      } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formShipping.opt_tras_documentid && formShipping.opt_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocumentOptTras();
    }   
    return () => { isMounted = false };
  }, [t,token,dispatch,formShipping.opt_tras_documentid,formShipping.opt_tras_store_id]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocumentDestTras = async () => {
      try { 
        const getData = await helpHttp().get2(ENDPOINT,`shipping/getexiststorebynumberdocument/`,token,formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData>0 && getData!==formShipping.dest_tras_store_id){
            fetchStoreNumberDocumentDestTras();
          }
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    const fetchStoreNumberDocumentDestTras = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`shipping/getstorebynumberdocumentpriority`,token,formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim(),4);
        if (getData.err) {
            dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          if (getData!==undefined && getData!==null && getData!==""){ 
            let street=(getData.street!==null && getData.street.street!==null)?getData.street.street+" ":"";
            let postalcode_postalcodename=(getData.street!==null && getData.street.postalcode_postalcodename!==null)?getData.street.postalcode_postalcodename:"";
            let adress=street+postalcode_postalcodename
           

            setFormShipping(formShipping => ({
              ...formShipping,
              dest_tras_store_id: getData.store_id, 
              dest_tras_tradename: getData.tradename,
              dest_tras_street:(adress!=="")?adress:formShipping.dest_tras_street,
              typeofprice_id: getData?.typeofprice_id ?? 1,
              typeofprice_namees: getData?.typeofprice_namees ?? "",
              typeofprice_nameen: getData?.typeofprice_nameen ?? "",
              paymenttype_id:  getData?.paymenttype_id ?? 1,
              paymenttype_code: getData?.paymenttype_code ?? "",
              paymenttype_namees: getData?.paymenttype_namees ?? "",
              paymenttype_nameen: getData?.paymenttype_nameen ?? "",
            }));
          }
          if (menuPermissions.canViewPrice && Number(formShipping.typeofprice_id)!==Number(getData?.typeofprice_id ?? 1) && formShipping?.linesshipping && formShipping.linesshipping.length>0 ){
            setOpenChangeTypeOfPrice(true);
          } 
        }         
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formShipping.dest_tras_documentid && formShipping.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocumentDestTras();
    }  
    return () => { isMounted = false };
  }, [t,token,dispatch,formShipping.dest_tras_store_id,formShipping.dest_tras_documentid,formShipping.linesshipping,formShipping.typeofprice_id,menuPermissions.canViewPrice]); 

  return ( 
      <>
        {showModalShippingsSettings ? ( 
         <div className="container-fluid formgeneral-send-wrapper shipping-form">
            <Box sx={{ bgcolor: '#ffffff', width: '100%', maxWidth: { xs: '930px', lg: '1200px' }, minWidth: 0 }}>
              <form autoComplete="off" onSubmit={handleCloseDataEditShipping}>  
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                        <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                        (isLoadingData?
                        <CircularProgress sx={{ color : "#f6c23e"}}/>:
                        <i className="fas fa-solid fa-truck text-warning"></i>)} 
                        &nbsp;&nbsp;{id==="0"?t('Text_SHIPPING_New'):t('Text_SHIPPING_Edit')+': '+formShipping.ownshipping_id.toString().padStart(6, '0')}
                    </div>
                    <div className="email-card-actions">
                      {isLoadingData?
                        <CircularProgress sx={{ color : "#f6c23e"}}/>:
                          <>
                            {menuPermissions.canViewCheck && (
                              <button
                                type="button"
                                className={`formgeneral-cancel-btn shipping-check-btn ${formShipping.chequeado ? 'shipping-check-checked' : 'shipping-check-pending'}`}
                                disabled={isSaving}
                                aria-pressed={Boolean(formShipping.chequeado)}
                                onClick={() => setFormShipping((prev) => ({
                                  ...prev,
                                  chequeado: !prev.chequeado,
                                }))}
                              >
                                {formShipping.chequeado ? t('Text_SHIPPING_Checked') : t('Text_SHIPPING_PendingCheck')}
                                {formShipping.chequeado
                                  ? <CheckCircleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />
                                  : <ScheduleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />
                                }
                              </button>
                            )}
                            <button type="button" className="formgeneral-send-btn" disabled={isSaving} onClick={handleSubmitDataEditShipping} >
                              {isSaving ? t('Text_Shipping_Saving') : id==="0"?t('Button_Create'):t('Button_Update')}
                            </button>
                            <button type="button" className="formgeneral-cancel-btn" disabled={isSaving} onClick={handleCloseDataEditShipping} >
                              {t('Button_Cancel')}
                            </button>
                            </>
                        } 
                    </div>
                  </div>
                </div>
                <br/> 
                {saveError && <div role="alert" className="alert alert-warning">{saveError}</div>}
                {/* FORM CARD */}
                {!isLoadingData ?
                  <>
                    <div className="formgeneral-card-form"> 
                      <div className="form-group">
                        <div className="row p-2 shipping-fields-grid"> 
                          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
<div className="shipping-field shipping-date-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_Date')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<DesktopDatePicker
                              id="date_shipping" 
                              name="date_shipping"
                              value={formShipping.date_shipping == null || formShipping.date_shipping === "" ? null : new Date(formShipping.date_shipping)}
                              format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                              inputProps={{ style: {width: 200}, maxLength: 100 }}
                              label={errorsForm.date_shipping!=null?t(errorsForm.date_shipping):t('Text_SHIPPING_Date')}
                              onChange={handleChangeSelectDate}
                              slotProps={{
                                textField: {
                                  onBlur: handleBlurSelectDate,
                                  error: Boolean(errorsForm.date_shipping),
                                  placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                  sx: {
                                    maxLength: 200,
                                    width: 200,
                                    fontSize: '18px',  
                                  },
                                  InputProps: {
                                    style: {
                                      fontSize: '18px',
                                    }
                                  },
                                  InputLabelProps:{ 
                                    style: {
                                      fontSize: '18px', 
                                      background: '#FFFFFF'
                                    }
                                  },
                                },
                              }}
                            />
</div>

</div>
</div>
</LocalizationProvider>
                            {menuPermissions.canViewPrice && 
                              <>
<div className="shipping-field shipping-total-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_TOTAL').toUpperCase()} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<NumericFormat 
                                  thousandSeparator=","
                                  decimalSeparator="."
                                  decimalScale={2}
                                  fixedDecimalScale
                                  allowNegative
                                  isAllowed={withValueCap3}
                                  id="total"
                                  name="total"
                                  suffix=" €"
                                  value={formShipping.totalnetoshipping}
                                  className="total-field-blue"
                                  disabled
                                />
</div>

</div>
</div>
</>
                            }
                        </div>
                        <div className="row p-2 shipping-fields-grid shipping-reference-grid"> 
                          {menuPermissions.canViewFormDI && 
                            <>
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORMDI_ASSOCIATED')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<TextField
                                id="ownformdi_id" 
                                name="ownformdi_id"
                                value={formShipping.ownformdi_id}
                                inputProps={{ style: {width: i18n.language==='es'?284:313,  fontSize: '18px', }, maxLength: 20 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.ownformdi_id!=null?t(errorsForm.ownformdi_id):t('Text_FORMDI_ASSOCIATED')}
                                placeholder={t('Text_FORMDI_ASSOCIATED')}
                                error={Boolean(errorsForm.ownformdi_id)}
                                variant="standard" 
                                disabled
                              />
</div>
<div className="shipping-field-actions"><IconButton  size="small" className={`deletesmall-${formShipping.ownformdi_id===""? "noselect-button ": "select-button" }`} disabled={formShipping.ownformdi_id===""}  onClick={deleteFORMDI}>
                                  <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>
<IconButton  size="small"  className="edit-select-button"  onClick={searchFORMDI}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton></div>
</div>
</div>
</>
                          }
                          {menuPermissions.canViewReference && 
                            <>
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_NUMBER')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<TextField
                                id="number_shipping" 
                                name="number_shipping"
                                value={formShipping.number_shipping}
                                inputProps={{ style: {width: i18n.language==='es'?220:344,  fontSize: '18px', }, maxLength: 20 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.number_shipping!=null?t(errorsForm.number_shipping):t('PLACEHOLDER_SHIPPING_NUMBER')}
                                placeholder={t('PLACEHOLDER_SHIPPING_NUMBER')}
                                error={Boolean(errorsForm.number_shipping)}
                                variant="standard"
                                onBlur={handleBlurDataEditShipping}
                                onChange={handleChangeDataEditShipping}
                              />
</div>

</div>
</div>
</>
                          }
                        </div>
                      </div>
                      

                      <Accordion className="accordionOptTras-root" expanded={expanded}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              onClick={handleAccordionToggle}
                              onFocus={stopPropagation}
                            />
                          }
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                          className="accordionOptTras-backcolor shipping-fields-summary"
                          onClick={stopPropagation}
                        >
                          <div className="form-group">
                            <div className="row p-2 shipping-fields-grid shipping-vehicles-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                {t("Text_SHIPPING_LICENSEPLATE")} :
                              </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<ShippingAutocompleteField
                              id="vehiclestore_licenseplate"
                              value={formShipping.vehiclestore_licenseplate}
                              errorKey={errorsForm.vehiclestore_licenseplate}
                              placeholder={t("Placeholder_SHIPPING_LICENSEPLATE")}
                              translate={t}
                              autocomplete={vehicleAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                vehiclestore_licenseplate: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.vehiclestore_licenseplate) + '-' + index}
                              renderItem={(item) => item.vehiclestore_licenseplate}
                              dropdownWidth="150%"
                              fullWidth={false}
                              inputWidth={150}
                            />
</div>
<div className="shipping-field-actions"><IconButton
                                size="small"
                                className="deletesmall-select-button"
                                onClick={(e) => {
                                  stopPropagation(e);
                                  deleteLicensePlate(e);
                                }}
                              >
                              <DeleteIcon style={{ fontSize: 28 }} />
                              </IconButton>
{roles[0].listmenus.find((key) => key.name === "SubMenu_Form_View_Stores") && (
                                <IconButton
                                  size="small"
                                  className="edit-select-button"
                                  onClick={(e) => { stopPropagation(e); searchVehicles(e); }}
                                >
                                  <SearchIcon style={{ fontSize: 28 }} />
                                </IconButton>
                              )}</div>
</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                {t("Text_SHIPPING_TRAILER")} :
                              </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<ShippingAutocompleteField
                              id="vehiclestore_trailer"
                              value={formShipping.vehiclestore_trailer}
                              errorKey={errorsForm.vehiclestore_trailer}
                              placeholder={t("Placeholder_SHIPPING_TRAILER")}
                              translate={t}
                              autocomplete={trailerAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                vehiclestore_trailer: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.vehiclestore_licenseplate) + '-' + index}
                              renderItem={(item) => item.vehiclestore_licenseplate}
                              dropdownWidth="150%"
                              fullWidth={false}
                              inputWidth={150}
                            />
</div>
<div className="shipping-field-actions"><IconButton
                                size="small"
                                className="deletesmall-select-button"
                                onClick={(e) => { stopPropagation(e); deleteTrailer(e); }}
                              >
                                <DeleteIcon style={{ fontSize: 28 }} />
                              </IconButton>
<IconButton
                                size="small"
                                className="edit-select-button"
                                onClick={(e) => { stopPropagation(e); setShowModalSearchTrailers(true); }}
                              >
                                <SearchIcon style={{ fontSize: 28 }} />
                              </IconButton></div>
</div>
</div>
</div>
                            <div className="form-group">
                              <div className="row p-2 shipping-fields-grid shipping-vehicle-types-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                    {t("Text_CraneModel")} :
                                  </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-3 text-right">
                                  <TextField
                                    id="cranemodel_id"
                                    name="cranemodel_id"
                                    value={ (formShipping.cranemodel_id === undefined || formShipping.cranemodel_id ===null || formShipping.cranemodel_id ===""
                                          || formShipping.cranemodel_id ==="0" || formShipping.cranemodel_id ===0)?0:formShipping.cranemodel_id}
                                    inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                                    style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                    variant="outlined"
                                    onBlur={handleBlurDataEditCraneModel}
                                    onChange={handleChangeDataCraneModel}
                                    error={Boolean(errorsForm.cranemodel_id)}
                                    fullWidth
                                    select
                                    SelectProps={{
                                      native: true,
                                      value: (formShipping.cranemodel_id === undefined || formShipping.cranemodel_id ===null || formShipping.cranemodel_id ===""
                                          || formShipping.cranemodel_id ==="0" || formShipping.cranemodel_id ===0)?0: formShipping.cranemodel_id
                                    }}> 
                                    <option key={0} value=""/>
                                    {craneModelTypeSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.namees:option.nameen}
                                      </option>
                                    ))}
                                  </TextField>
                                </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                    {t("Text_SemiTrailerType")} :
                                  </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-right">
                                  <TextField
                                    id="semitrailertype_id"
                                    name="semitrailertype_id"
                                    value={ (formShipping.semitrailertype_id === undefined || formShipping.semitrailertype_id ===null || formShipping.semitrailertype_id ===""
                                          || formShipping.semitrailertype_id ==="0" || formShipping.semitrailertype_id ===0)?0:formShipping.semitrailertype_id}
                                    inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                                    style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                    variant="outlined"
                                    onBlur={handleBlurDataEditTypeOfSemiTrailer}
                                    onChange={handleChangeDataTypeOfSemiTrailer}
                                    error={Boolean(errorsForm.semitrailertype_id)}
                                    fullWidth
                                    select
                                    SelectProps={{
                                      native: true,
                                      value: (formShipping.semitrailertype_id === undefined || formShipping.semitrailertype_id ===null || formShipping.semitrailertype_id ===""
                                          || formShipping.semitrailertype_id ==="0" || formShipping.semitrailertype_id ===0)?0: formShipping.semitrailertype_id
                                    }}> 
                                    <option key={0} value=""/>
                                    {semiTrailerTypeSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.namees:option.nameen}
                                      </option>
                                    ))}
                                  </TextField>
                                </div>
</div>

</div>
</div>
</div>
                            </div>
                          </div>
                            
                        </AccordionSummary>
                          <AccordionDetails onClick={stopPropagation} onMouseDown={stopPropagation}>
                            <div className="accordion-inner-box">
                              <div className="form-group">
                                <div className="row p-2 shipping-fields-grid shipping-carrier-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                      {t("Text_SHIPPING_REL_TRANS")} :
                                    </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                                    <ShippingAutocompleteField
                              id="rel_trans_tradename"
                              value={formShipping.rel_trans_tradename}
                              errorKey={errorsForm.rel_trans_tradename}
                              placeholder={t("Placeholder_SHIPPING_REL_TRANS")}
                              translate={t}
                              autocomplete={relTransTradenameAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                rel_trans_tradename: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.tradename) + '-' + index}
                              renderItem={(item) => <>{item.tradename} - {item.documentid}</>}
                              dropdownWidth="180%"
                            />
                                  </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>
                                      {t("Text_SHIPPING_CIF")} :
                                    </label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-2 text-left">
                                    <ShippingAutocompleteField
                              id="rel_trans_documentid"
                              value={formShipping.rel_trans_documentid}
                              errorKey={errorsForm.rel_trans_documentid}
                              placeholder={t("Placeholder_SHIPPING_CIF")}
                              translate={t}
                              autocomplete={relTransDocumentIdAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                rel_trans_documentid: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.documentid) + '-' + index}
                              renderItem={(item) => <>{item.documentid} - {item.tradename}</>}
                              dropdownWidth="180%"
                            />
                                  </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                                    <IconButton
                                      size="small"
                                      className="deletesmall-select-button"
                                      onClick={(e) => {
                                        stopPropagation(e);
                                        deleteStoreRelTrans(e);
                                      }}
                                    >
                                      <DeleteIcon style={{ fontSize: 28 }} />
                                    </IconButton> 
                                    &nbsp;&nbsp; 
                                    {roles[0].listmenus.find((key) => key.name === "SubMenu_Shipping_View_Stores") && (
                                      <IconButton
                                        size="small"
                                        className="edit-select-button"
                                        onClick={(e) => {
                                          stopPropagation(e);
                                          searchStoreRelTrans(e);
                                        }}
                                      >
                                        <SearchIcon style={{ fontSize: 28 }} />
                                      </IconButton>
                                    )}
                                  </div></div>
</div>
</div>
</div>
                                
                                <div className="row p-2 shipping-fields-grid">
<div className="shipping-field shipping-address-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_REL_TRANS_STREET')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-7 text-left">
                                    <TextField
                                      id="rel_trans_street" 
                                      name="rel_trans_street"
                                      value={formShipping.rel_trans_street}
                                      onClick={stopPropagation}
                                      onFocus={stopPropagation}
                                      inputProps={{ style: {fontSize: '18px', }, maxLength: 255 }}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                      label={errorsForm.rel_trans_street!=null?t(errorsForm.rel_trans_street):t('Placeholder_SHIPPING_REL_TRANS_STREET')}
                                      placeholder={t('Placeholder_SHIPPING_REL_TRANS_STREET')}
                                      variant="standard"
                                      fullWidth
                                      onBlur={handleBlurDataEditShipping}
                                      onChange={handleChangeDataEditShipping}
                                      error={Boolean(errorsForm.rel_trans_street)}
                                    />
                                  </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                                    <IconButton  size="small"  className="deletesmall-select-button" onClick={(e) => { stopPropagation(e); deleteAddresStoreRelTrans(e);}}>
                                      <DeleteIcon style={{fontSize: 28}}/>
                                    </IconButton>  
                                    &nbsp;&nbsp;
                                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Stores'))&&
                                      <IconButton  size="small" className={`edit-${formShipping.rel_trans_documentid===""? "noselect-button ": "select-button" }`} disabled={formShipping.rel_trans_documentid===""}  onClick={(e) => {stopPropagation(e);searchAddresStoreRelTrans(e);}}>
                                        <SearchIcon style={{fontSize: 28}}/>
                                      </IconButton>   
                                    } 
                                  </div></div>
</div>
</div>
</div> 
                              </div>   
                              <div className="form-group">  
                                <div className="row p-2 shipping-fields-grid shipping-carrier-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_DRIVER')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                                    <ShippingAutocompleteField
                              id="vehiclestore_defaultdriver"
                              value={formShipping.vehiclestore_defaultdriver}
                              errorKey={errorsForm.vehiclestore_defaultdriver}
                              placeholder={t("Placeholder_SHIPPING_DRIVER")}
                              translate={t}
                              autocomplete={driverTradenameAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                vehiclestore_defaultdriver: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.tradename) + '-' + index}
                              renderItem={(item) => <>{item.tradename} - {item.documentid}</>}
                              dropdownWidth="180%"
                            />  
                                  </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_NIF')}</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-2 text-left">
                                    <ShippingAutocompleteField
                              id="vehiclestore_documentid"
                              value={formShipping.vehiclestore_documentid}
                              errorKey={errorsForm.vehiclestore_documentid}
                              placeholder={t("Placeholder_SHIPPING_NIF")}
                              translate={t}
                              autocomplete={driverDocumentIdAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                vehiclestore_documentid: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.documentid) + '-' + index}
                              renderItem={(item) => <>{item.documentid} - {item.tradename}</>}
                              dropdownWidth="180%"
                            />
                                </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                                  <IconButton  size="small"  className="deletesmall-select-button"  onClick={(e) => { stopPropagation(e);deleteADriverStoreRelTrans(e);}}>
                                    <DeleteIcon style={{fontSize: 28}}/>
                                  </IconButton>    
                                  &nbsp;&nbsp;
                                  {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                                  <IconButton  size="small"  className="edit-select-button" onClick={(e) => { stopPropagation(e);searchDRIVER(e);}}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                  </IconButton>
                                }
                                </div></div>
</div>
</div>
</div>
                            </div> 
                          </div>
                        </AccordionDetails> 
                      </Accordion>
                      {menuPermissions.canViewOptTras && 
                        <>
                          <Accordion className="accordionOptTras-root" expanded={expandedOpt}>
                            <AccordionSummary
                              expandIcon={
                                <ExpandMoreIcon
                                  onClick={handleAccordionOptToggle}
                                  onFocus={stopPropagation}
                                />
                              }
                              aria-controls="panel2bh-content"
                              id="panel2bh-header"
                              className="accordionOptTras-backcolor shipping-fields-summary shipping-recipient-summary"
                              onClick={stopPropagation}
                            >
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_OPT_TRAS')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                                <ShippingAutocompleteField
                              id="opt_tras_tradename"
                              value={formShipping.opt_tras_tradename}
                              errorKey={errorsForm.opt_tras_tradename}
                              placeholder={t("Placeholder_SHIPPING_OPT_TRAS")}
                              translate={t}
                              autocomplete={optTrasTradenameAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                opt_tras_tradename: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.tradename) + '-' + index}
                              renderItem={(item) => <>{item.tradename} - {item.documentid}</>}
                              dropdownWidth="180%"
                            />  
                              </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_CIF')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-2 text-left">
                                <ShippingAutocompleteField
                              id="opt_tras_documentid"
                              value={formShipping.opt_tras_documentid}
                              errorKey={errorsForm.opt_tras_documentid}
                              placeholder={t("Placeholder_SHIPPING_CIF")}
                              translate={t}
                              autocomplete={optTrasDocumentIdAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                opt_tras_documentid: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.documentid) + '-' + index}
                              renderItem={(item) => <>{item.documentid} - {item.tradename}</>}
                              dropdownWidth="180%"
                            />   
                              </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right"> 
                                <IconButton  size="small"  className="deletesmall-select-button"  
                                onClick={(e) => {
                                  stopPropagation(e);
                                  deleteStoreOptTras(e);
                                }}>
                                  <DeleteIcon style={{fontSize: 28}}/>
                                </IconButton>  
                                &nbsp;&nbsp;
                                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Stores'))&&
                                  <IconButton  size="small"  className="edit-select-button" 
                                  onClick={(e) => {
                                    stopPropagation(e);
                                    searchStoreOptTras(e);
                                  }}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                  </IconButton>  
                                }  
                              </div></div>
</div>
</div>
</AccordionSummary>
                            <AccordionDetails onClick={stopPropagation} onMouseDown={stopPropagation}>
                              <div className="accordion-inner-box">
                                <div className="form-group">  
                                  <div className="row p-2 shipping-fields-grid">
<div className="shipping-field shipping-address-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_STREET')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-7 text-left">
                                      <TextField
                                        id="opt_tras_street" 
                                        name="opt_tras_street"
                                        value={formShipping.opt_tras_street}
                                        onClick={stopPropagation}
                                        onFocus={stopPropagation}
                                        inputProps={{ style: { fontSize: '18px', }, maxLength: 100 }}
                                        style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        label={errorsForm.opt_tras_street!=null?t(errorsForm.opt_tras_street):t('Placeholder_SHIPPING_STREET')}
                                        placeholder={t('Placeholder_SHIPPING_STREET')}
                                        variant="standard"
                                        error={Boolean(errorsForm.opt_tras_street)}
                                        fullWidth
                                        onBlur={handleBlurDataEditShipping}
                                        onChange={handleChangeDataEditShipping}
                                      />
                                    </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                                      <IconButton  size="small"  className="deletesmall-select-button" onClick={(e) => { stopPropagation(e);deleteAddresStoreOptTras(e);}}>
                                        <DeleteIcon style={{fontSize: 28}}/>
                                      </IconButton> 
                                      &nbsp;&nbsp;
                                      {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Stores'))&&
                                        <IconButton  size="small" className={`edit-${formShipping.opt_tras_documentid===""? "noselect-button ": "select-button" }`} disabled={formShipping.opt_tras_documentid===""} onClick={(e) => { stopPropagation(e);searchAddresStoreOptTras(e);}}>
                                            <SearchIcon style={{fontSize: 28}}/>
                                        </IconButton>   
                                      } 
                                    </div></div>
</div>
</div>
</div>
                                </div>
                              </div>
                            </AccordionDetails> 
                          </Accordion>
                        </>
                      }
                      <Accordion className="accordionOptTras-root" expanded={expandedDest}>
                        <AccordionSummary
                          expandIcon={
                            <ExpandMoreIcon
                              onClick={handleAccordionDestToggle}
                              onFocus={stopPropagation}
                            />
                          }
                          aria-controls="panel3bh-content"
                          id="panel3bh-header"
                          className="accordionOptTras-backcolor shipping-fields-summary shipping-recipient-summary"
                          onClick={stopPropagation}
                        >
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_DEST_TRAS')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                            <ShippingAutocompleteField
                              id="dest_tras_tradename"
                              value={formShipping.dest_tras_tradename}
                              errorKey={errorsForm.dest_tras_tradename}
                              placeholder={t("Placeholder_SHIPPING_DEST_TRAS")}
                              translate={t}
                              autocomplete={destTrasTradenameAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                dest_tras_tradename: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.tradename) + '-' + index}
                              renderItem={(item) => <>{item.tradename} - {item.documentid}</>}
                              dropdownWidth="180%"
                            />  
                          </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_CIF')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-2 text-left">
                            <ShippingAutocompleteField
                              id="dest_tras_documentid"
                              value={formShipping.dest_tras_documentid}
                              errorKey={errorsForm.dest_tras_documentid}
                              placeholder={t("Placeholder_SHIPPING_CIF")}
                              translate={t}
                              autocomplete={destTrasDocumentIdAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                dest_tras_documentid: value,
                              }))}
                              getItemKey={(store, index) => store.id || `${store.documentid}-${index}`}
                              renderItem={(store) => `${store.documentid} - ${store.tradename}`}
                            />
                          </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                            <IconButton  size="small"  className="deletesmall-select-button"  onClick={(e) => { stopPropagation(e); deleteStoreDestTras(e); }}>
                              <DeleteIcon style={{fontSize: 28}}/>
                            </IconButton> 
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Stores'))&&
                              <IconButton  size="small"  className="edit-select-button"  onClick={(e) => { stopPropagation(e); searchStoreDestTras(e); }}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton> 
                            }  
                          </div></div>
</div>
</div>
</AccordionSummary>
                        <AccordionDetails onClick={stopPropagation} onMouseDown={stopPropagation}>
                          <div className="accordion-inner-box">
                            <div className="form-group">  
                              <div className="row p-2 shipping-fields-grid">
<div className="shipping-field shipping-address-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_STREET')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-7 text-left">
                                  <TextField
                                    id="dest_tras_street" 
                                    name="dest_tras_street"
                                    value={formShipping.dest_tras_street}
                                    onClick={stopPropagation}
                                    onFocus={stopPropagation}
                                    inputProps={{ style: {fontSize: '18px' }, maxLength: 100 }}
                                    style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.dest_tras_street!=null?t(errorsForm.dest_tras_street):t('Placeholder_SHIPPING_STREET')}
                                    placeholder={t('Placeholder_SHIPPING_STREET')}
                                    variant="standard"
                                    error={Boolean(errorsForm.dest_tras_street)}
                                    fullWidth
                                    onBlur={handleBlurDataEditShipping}
                                    onChange={handleChangeDataEditShipping}
                                  />
                                </div>
</div>
<div className="shipping-field-actions"><div className="col-2 text-right">
                                  <IconButton  size="small"  className="deletesmall-select-button"  onClick={(e) => { stopPropagation(e); deleteAddresStoreDestTras(e);}}>
                                    <DeleteIcon style={{fontSize: 28}}/>
                                  </IconButton>  
                                  &nbsp;&nbsp;
                                  {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Shipping_View_Stores'))&&
                                    <IconButton  size="small" className={`edit-${formShipping.dest_tras_documentid===""? "noselect-button ": "select-button" }`} disabled={formShipping.dest_tras_documentid===""} onClick={(e) => { stopPropagation(e); searchAddresStoreDestTras(e);}} >
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>  
                                  }
                               </div></div>
</div>
</div>
</div>
                            </div>
                            {menuPermissions.canViewPrice && 
                              <> 
                                <div className="row shipping-fields-grid shipping-payment-grid">
<div className="shipping-field">
<label className="text-primary">{t('Text_PriceType').toUpperCase()} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-right">
                                    <TextField
                                      id="typeofprice_id"
                                      name="typeofprice_id"
                                      value={ (formShipping.typeofprice_id === undefined || formShipping.typeofprice_id ===null || formShipping.typeofprice_id ===""
                                            || formShipping.typeofprice_id ==="0" || formShipping.typeofprice_id ===0)?1:formShipping.typeofprice_id}
                                      inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      variant="outlined"
                                      onBlur={handleBlurDataEditTypeOfPrice}
                                      onChange={handleChangeDataTypeOfPrice}
                                      error={Boolean(errorsForm.typeofprice_id)}
                                      fullWidth
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formShipping.typeofprice_id === undefined || formShipping.typeofprice_id ===null || formShipping.typeofprice_id ===""
                                            || formShipping.typeofprice_id ==="0" || formShipping.typeofprice_id ===0)?1: formShipping.typeofprice_id
                                      }}> 
                                      {typeOfPriceSelect.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {i18n.language==="es"?option.namees:option.nameen}
                                        </option>
                                      ))}
                                    </TextField>
                                  </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_PaymentType').toUpperCase()} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-right">
                                    <TextField
                                      id="paymenttype_id"
                                      name="paymenttype_id"
                                      value={ (formShipping.paymenttype_id === undefined || formShipping.paymenttype_id ===null || formShipping.paymenttype_id ===""
                                            || formShipping.paymenttype_id ==="0" || formShipping.paymenttype_id ===0)?1:formShipping.paymenttype_id}
                                      inputProps={{ style: {fontSize: '18px', }, maxLength: 100 }}
                                      style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                      variant="outlined"
                                      onBlur={handleBlurDataEditShipping}
                                      onChange={handleChangeDataEditShipping}
                                      error={Boolean(errorsForm.paymenttype_id)}
                                      fullWidth
                                      select
                                      SelectProps={{
                                        native: true,
                                        value: (formShipping.paymenttype_id === undefined || formShipping.paymenttype_id ===null || formShipping.paymenttype_id ===""
                                            || formShipping.paymenttype_id ==="0" || formShipping.paymepaymenttype_idt_id ===0)?1: formShipping.paymenttype_id
                                      }}> 
                                      {paymentTypeSelect.map((option) => (
                                      <option key={option.id} value={option.id}>
                                          {i18n.language==="es"?option.namees:option.nameen}
                                      </option>
                                      ))}
                                    </TextField>
                                  </div>
</div>

</div>
</div>
</div>     
                              </>
                            }

                          </div>
                        </AccordionDetails> 
                      </Accordion>
                      <div className="form-group">  
                        <div className={`row p-2 shipping-fields-grid shipping-route-grid${canViewExpandedDestination ? " shipping-route-grid--expanded" : ""}`}>
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_ORIGIN')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                            <ShippingAutocompleteField
                              id="origin_street"
                              value={formShipping.origin_street}
                              errorKey={errorsForm.origin_street}
                              placeholder={t("Placeholder_SHIPPING_ORIGIN")}
                              translate={t}
                              autocomplete={workkPlaceOriginAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                origin_street: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.workplace) + '-' + index}
                              renderItem={(item) => item.workplace}
                              dropdownWidth="100%"
                            />   
                          </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_DESTINATION')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-4 text-left">
                            {canViewExpandedDestination ? (
                              <TextField
                                id="destine_street"
                                fullWidth
                                multiline
                                rows={5}
                                variant="outlined"
                                className="shipping-expanded-destination"
                                value={formShipping.destine_street || ""}
                                placeholder={t("Placeholder_SHIPPING_DESTINATION")}
                                error={Boolean(errorsForm.destine_street)}
                                helperText={errorsForm.destine_street ? t(errorsForm.destine_street) : "Máximo 30 líneas"}
                                onChange={(event) => {
                                  const value = event.target.value;
                                  if (value.split(/\r\n|\r|\n/).length <= 30) {
                                    setFormShipping(prev => ({ ...prev, destine_street: value }));
                                  }
                                }}
                              />
                            ) : (
                            <ShippingAutocompleteField
                              id="destine_street"
                              value={formShipping.destine_street}
                              errorKey={errorsForm.destine_street}
                              placeholder={t("Placeholder_SHIPPING_DESTINATION")}
                              translate={t}
                              autocomplete={workkPlaceDestineAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                destine_street: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.workplace) + '-' + index}
                              renderItem={(item) => item.workplace}
                              dropdownWidth="100%"
                            />
                            )}   
                          </div>
</div>

</div>
</div>
</div>  

                         <div className="row p-2 shipping-fields-grid shipping-workplace-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_WORKPLACE')} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-9 text-left">
                            <ShippingAutocompleteField
                              id="workplace"
                              value={formShipping.workplace}
                              errorKey={errorsForm.workplace}
                              placeholder={t("Placeholder_SHIPPING_WORKPLACE")}
                              translate={t}
                              autocomplete={workkPlaceAutocomplete}
                              onValueChange={(value) => setFormShipping((prev) => ({
                                ...prev,
                                workplace: value,
                              }))}
                              getItemKey={(item, index) => item.id || String(item.workplace) + '-' + index}
                              renderItem={(item) => item.workplace}
                              dropdownWidth="100%"
                            />   
                          </div>
</div>

</div>
</div>
</div>  
                      </div> 
                      <hr className="sidebar-divider d-none d-md-block"/>

                      <ShippingWorkOptions
                        t={t}
                        language={i18n.language}
                        hours={formShipping.hours}
                        withCrane={formShipping.withcrane}
                        withoutCrane={formShipping.withoutcrane}
                        adr={formShipping.adr}
                        others={formShipping.others}
                        onHoursBlur={handleBlurSelectHours}
                        onHoursChange={handleChangeSelectHours}
                        onWithCraneChange={handleChangeWithCrane}
                        onWithoutCraneChange={handleChangeWitOutCrane}
                        onAdrChange={handleChangeWitOutADR}
                        onOthersChange={handleChangeWitOutOTHERS}
                      />

                      
                      <div className="form-group"> 
                        <div className="row p-2 shipping-fields-grid shipping-service-grid">
<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_SERVICE').toUpperCase()} :</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-7 text-left">
                            <TextField
                              id="service_1" 
                              name="service_1"
                              value={formShipping.service_1}
                              inputProps={{ maxLength: 100 }}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              style={{width:'100%', fontSize: 18, textAlign:'right', paddingRight:5}} 
                              label={errorsForm.service_1!=null?t(errorsForm.service_1):t('Placeholder_SHIPPING_SERVICE')}
                              placeholder={t('Placeholder_SHIPPING_SERVICE')}
                              variant="standard"
                              onBlur={handleBlurDataEditShipping}
                              onChange={handleChangeDataEditShipping}
                              error={Boolean(errorsForm.service_1)}
                            /> 
                          </div>
</div>

</div>
</div>

<div className="shipping-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_WEIGHT')}:</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-2 text-left">
                            <NumericFormat 
                              thousandSeparator={','} 
                              decimalSeparator={'.'} 
                              decimalScale= {2}
                              fixedDecimalScale= {true}
                              allowNegative= {false}
                              isAllowed={withValueCap}
                              id="weight" 
                              name="weight"
                              suffix={" kg"}
                              value={formShipping.weight}
                              className="numeric-field"
                              onBlur={handleBlurDataEditShippingWeight}
                              onChange={handleChangeDataEditShippingWeight}
                            />  
                          </div>
</div>

</div>
</div>
</div>  
                      </div>  
                      <hr className="sidebar-divider d-none d-md-block"/>

                      <div className="formdi-pending-card-flat">
                        <div className="formdi-pending-card-content">
                          <TableSortingShippingArticleList
                            dataArticles={formShipping.linesshipping} 
                            numTotRegArticles={formShipping.linesshipping.length}
                            setOpenDeleteRowArticles={setOpenDeleteRowArticles}
                            setEditRowArticles={setEditRowArticles}
                            formShipping={formShipping}                                  
                            setFormShipping={setFormShipping}
                            setShowModalSearchArticles={setShowModalSearchArticles}
                            menuPermissions={menuPermissions}
                          />
                      </div>
                    </div>
                    <div className="row p-2 shipping-fields-grid">
<div className="shipping-field shipping-observations-field">
<label className="text-primary" style={{ fontSize: 18 }}>{t('Text_SHIPPING_OBSERVATIONS')}:</label>
<div className="shipping-field-controls">
<div className="shipping-field-input">
<div className="col-9 text-left">
                        <TextField
                          id="observations" 
                          name="observations"
                          value={formShipping.observations}
                          inputProps={{ maxLength: 100 }}
                          InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                          style={{width:'100%', fontSize: 18, textAlign:'right', paddingRight:5}} 
                          label={errorsForm.observations!=null?t(errorsForm.observations):t('Placeholder_SHIPPING_OBSERVATIONS')}
                          placeholder={t('Placeholder_SHIPPING_OBSERVATIONS')}
                          variant="standard"
                          error={Boolean(errorsForm.observations)}
                          fullWidth
                          onBlur={handleBlurDataEditShipping}
                          onChange={handleChangeDataEditShipping}
                        />            
                      </div>
</div>

</div>
</div>
</div>   
                     
                    <ShippingMedia files={formShipping.updatedFiles || []}
                      onChange={(updatedFiles) => setFormShipping(previous => ({ ...previous, updatedFiles }))}
                      onBusyChange={setMediaBusy} disabled={isSaving} />
                    <div className={`sigblock-container${canViewInspectorSignature ? " sigblock-container--three" : ""}`}>
                    {canViewInspectorSignature && (<>
                      {/* === FIRMA INTERVENTOR === */}
                      <div className="sigblock-item">
                        <Card className="sigblock-card">
                          <CardContent className="sigblock-card-content">
                            <div className="sigblock-canvas">
                              <SignatureCanvas
                                clearOnResize={false}
                                penColor="black"
                                ref={signDispatchedInspectorCanvas}
                                canvasProps={{
                                  width: CLIENT_CANVAS_WIDTH,
                                  height: CLIENT_CANVAS_DOUBLE_HEIGHT,
                                  style: {
                                    width: "100%",
                                    height: `${CLIENT_CANVAS_DOUBLE_HEIGHT}px`,
                                    display: "block"
                                  }
                                }}
                              />  
                            </div>
                            <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => handleSetSignatureInspector()}
                              disabled={defaultsignature===""}>
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(3)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div> 
                          </CardContent>
                          <Typography className="sigblock-title">
                            {t("Text_Signature_inspector")}
                          </Typography>
                        </Card>
                      </div>
                    </>)}
                      {/* === FIRMA CHÓFER === */}
                      <div className="sigblock-item">
                        <Card className="sigblock-card">
                          <CardContent className="sigblock-card-content">
                            <div className="sigblock-canvas">
                                <SignatureCanvas
                                clearOnResize={false}
                                penColor="black"
                                ref={signDispatchedDriverCanvas}
                                canvasProps={{
                                  width: CLIENT_CANVAS_WIDTH,
                                  height: CLIENT_CANVAS_DOUBLE_HEIGHT,
                                  style: {
                                    width: "100%",
                                    height: `${CLIENT_CANVAS_DOUBLE_HEIGHT}px`,
                                    display: "block"
                                  }
                                }}
                              /> 
                            </div>
                            <div className="sigblocksign-actions">
                              <Button className="sigblocksign-btn sigblocksign-btn-user"
                                onClick={() => handleSetSignatureDriver()}
                                disabled={defaultsignature===""}>
                                {t("Button_Sign_User")}
                              </Button> 
                              <Button
                                className="sigblocksign-btn sigblocksign-btn-delete"
                                onClick={() => deleteSignature(1)}
                              >
                                {t("Button_Delete")}
                              </Button>
                            </div>
                          </CardContent>
                          <Typography className="sigblock-title">
                            {t("Text_Signature_driver")}
                          </Typography>
                        </Card>
                      </div>

                      {/* === FIRMA CARGADOR === */}
                      <div className="sigblock-item">
                        <Card className="sigblock-card">
                          <CardContent className="sigblock-card-content">
                            <div className="sigblock-canvas">
                              <SignatureCanvas
                                clearOnResize={false}
                                penColor="black"
                                ref={signDispatchedChargerCanvas}
                                canvasProps={{
                                  width: CLIENT_CANVAS_WIDTH,
                                  height: CLIENT_CANVAS_DOUBLE_HEIGHT,
                                  style: {
                                    width: "100%",
                                    height: `${CLIENT_CANVAS_DOUBLE_HEIGHT}px`,
                                    display: "block"
                                  }
                                }}
                              />  
                            </div>
                            <div className="sigblocksign-actions">
                            <Button className="sigblocksign-btn sigblocksign-btn-user"
                              onClick={() => handleSetSignatureCharger()}
                              disabled={defaultsignature===""}>
                              {t("Button_Sign_User")}
                            </Button> 
                            <Button
                              className="sigblocksign-btn sigblocksign-btn-delete"
                              onClick={() => deleteSignature(2)}
                            >
                              {t("Button_Delete")}
                            </Button>
                          </div> 
                          </CardContent>
                          <Typography className="sigblock-title">
                            {t("Text_Signature_charger")}
                          </Typography>
                        </Card>
                      </div>
 
                    </div>
                    <div className="formgeneral-card-form">
                        <div className="row p-2 shipping-fields-grid"> 
                          <Box sx={{ width: "100%" }}>
                            <div className="empbtns-grid">
                              {articlesButtonsList.map((post, index) => (
                                <Button
                                  key={index}
                                  variant="contained"
                                  className="empbtn-tile"
                                  style={{ "--btn-base": post.button_color }}
                                  onClick={() => selectArticle(post)}
                                >
                                  {i18n.language === "es" ? post.button_namees : post.button_nameen}
                                </Button>
                              ))}
                            </div>
                          </Box> 
                        </div>
                      </div> 
                  </div>
                </>:
                  <LoadingNews/>
                } 
                {!isLoadingData && (
                  <div className="shipping-footer-actions">
                    {menuPermissions.canViewCheck && (
                      <button
                        type="button"
                        className={`formgeneral-cancel-btn shipping-check-btn ${formShipping.chequeado ? 'shipping-check-checked' : 'shipping-check-pending'}`}
                        disabled={isSaving}
                        aria-pressed={Boolean(formShipping.chequeado)}
                        onClick={() => setFormShipping((prev) => ({
                          ...prev,
                          chequeado: !prev.chequeado,
                        }))}
                      >
                        {formShipping.chequeado ? t('Text_SHIPPING_Checked') : t('Text_SHIPPING_PendingCheck')}
                                {formShipping.chequeado
                                  ? <CheckCircleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />
                                  : <ScheduleRoundedIcon aria-hidden="true" sx={{ ml: 1, fontSize: '1.25em' }} />
                                }
                      </button>
                    )}
                    <button type="button" className="formgeneral-send-btn" disabled={isSaving} onClick={handleSubmitDataEditShipping}>
                      {isSaving ? t('Text_Shipping_Saving') : id === "0" ? t('Button_Create') : t('Button_Update')}
                    </button>
                    <button type="button" className="formgeneral-cancel-btn" disabled={isSaving} onClick={handleCloseDataEditShipping}>
                      {t('Button_Cancel')}
                    </button>
                  </div>
                )}
              </form>
            </Box>
            <ShippingSearchOverlays
              formShipping={formShipping}
              setFormShipping={setFormShipping}
              selectStores={tetxtSearch}
              menuPermissions={menuPermissions}
              setOpenChangeTypeOfPrice={setOpenChangeTypeOfPrice}
              articleSearch={{ open: showModalSearchArticles, setOpen: setShowModalSearchArticles }}
              diSearch={{ open: showModalSearchDI, setOpen: setShowModalSearchDI }}
              driverSearch={{ open: showModalSearchDrivers, setOpen: setShowModalSearchDrivers }}
              storeSearch={{ open: showModalSearchStores, setOpen: setShowModalSearchStores }}
              storeAddressSearch={{ open: showModalSearchStoresAddress, setOpen: setShowModalSearchStoresAddress }}
              vehicleSearch={{ open: showModalSearchVehicles, setOpen: setShowModalSearchVehicles }}
              trailerSearch={{ open: showModalSearchTrailers, setOpen: setShowModalSearchTrailers }}
            />
            <ShippingDialogs
              t={t}
              language={i18n.language}
              openChangeTypeOfPrice={openChangeTypeOfPrice}
              onConfirmChangeTypeOfPrice={handleConfirmChangeTypeOfPrice}
              onCancelChangeTypeOfPrice={handleCancelChangeTypeOfPrice}
              openDeleteRowArticles={openDeleteRowArticles}
              editRowArticles={editRowArticles}
              idCodeDeleteArticle={idCodeDeleteArticle}
              onChangeDeleteRow={handleChangeDeleteRow}
              onConfirmDeleteRow={handleCloseDeleteRow}
              onCancelDeleteRow={handleCancelDeleteRow}
            />
            <br/> 
        </div>
      //* End Page Content *//
      ) :  null }
    </>
  )    
}

ShippingEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalShippingsSettings: PropTypes.bool.isRequired
};

export default ShippingEditOrCreate;
